import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Observer from 'react-intersection-observer';
import HeaderElements from './header/header_elements';
import HeaderAd from './ad/header_ad';
import GeolocationBanner from './geolocation_banner';
import {
  GLOBAL_HEADER_CLASS_NAME,
  PRODUCT_LIST_PAGE_TYPE
} from '../constants';
import classNames from 'classnames';
import {omit} from 'lodash';

const Aux = props => props.children;

export class Header extends Component {

  constructor(props) {
    super(props);
    this.state = {menuIsOpen: false}
  }

  setMenuIsOpen = (open) => {
    this.setState({menuIsOpen: open});
  }


  onClickGeolocationBanner = () =>
    this.props.setShouldShowGeolocationBanner(false);

  render() {
    const headerClassNames = {
      'on-non-homepage-product-list': (
        this.props.page_type === PRODUCT_LIST_PAGE_TYPE
        && !this.props.isShoppingHome
      ),
      'menu-open': this.state.menuIsOpen
    };

    return (
      <Aux>
        {this.props.shouldDisplayAd &&
          <div className="header-ad-container" ref={this.props.headerAdRef}>
            <HeaderAd adsState={this.props.adsState} />
          </div>
        }
        <header
          role="banner"
          aria-label="Primary"
          className={classNames(GLOBAL_HEADER_CLASS_NAME, headerClassNames)}
        >
          <HeaderElements {...this.props} setMenuIsOpen={this.setMenuIsOpen}/>
          {this.props.shouldShowGeolocationBanner &&
              <GeolocationBanner
                geolocation={this.props.geolocation}
                onClick={this.onClickGeolocationBanner}
              />
          }
        </header>
      </Aux>
    );
  }
}

Header.propTypes = {
  // These two props are provided by the wrapping <Observer/> below.
  headerAdIsInView: PropTypes.bool.isRequired,
  headerAdRef: PropTypes.func,

  adsState: PropTypes.object.isRequired,
  navigationItems: PropTypes.arrayOf(
    PropTypes.object.isRequired
  ).isRequired,
  trendingItems: PropTypes.shape({
    videos: PropTypes.object,
    stories: PropTypes.object
  }).isRequired,
  page_type: PropTypes.string.isRequired,
  pageId: PropTypes.number,
  shouldDisplayAd: PropTypes.bool.isRequired,
  hasHeroModule: PropTypes.bool.isRequired,
  isShoppingHome: PropTypes.bool.isRequired,
  geolocation: PropTypes.string,
  shouldShowGeolocationBanner: PropTypes.bool.isRequired,
  setShouldShowGeolocationBanner: PropTypes.func.isRequired
};

const WrappedHeader = props =>
  props.shouldDisplayAd
    ? (
      <Observer>
        {
          ({ inView, ref }) =>
            <Header
              headerAdIsInView={inView}
              headerAdRef={ref}
              {...props}
            />
        }
      </Observer>
    )
    /*
     * We should not use the Observer at all if there's no
     * header ad - `react-intersection-observer` will error
     * when the dom node isn't there.
     */
    : (
      <Header
        headerAdIsInView={false}
        headerAdRef={null}
        {...props}
      />
    );

WrappedHeader.propTypes = omit(
  Header.propTypes,
  ['headerAdIsInView', 'headerAdRef']
);

export default WrappedHeader;
